export default __webpack_public_path__ + "static/media/catlow_thumb500px.15f0322e.jpg";